"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIntersectionObserver = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var useIntersectionObserver = exports.useIntersectionObserver = function useIntersectionObserver(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? null : _ref$root,
    _ref$rootMargin = _ref.rootMargin,
    rootMargin = _ref$rootMargin === void 0 ? '0px 0px 500px 0px' : _ref$rootMargin,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0.5 : _ref$threshold;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    entry = _useState2[0],
    updateEntry = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    node = _useState4[0],
    setNode = _useState4[1];
  var observer = (0, _react.useRef)(new window.IntersectionObserver(function (_ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 1),
      entry = _ref3[0];
    return updateEntry(entry);
  }, {
    root: root,
    rootMargin: rootMargin,
    threshold: threshold
  }));
  (0, _react.useEffect)(function () {
    var currentObserver = observer.current;
    currentObserver.disconnect();
    if (node) currentObserver.observe(node);
    return function () {
      return currentObserver.disconnect();
    };
  }, [node]);
  var shouldLoadMore = (entry === null || entry === void 0 ? void 0 : entry.intersectionRatio) >= 0.5;
  return [setNode, shouldLoadMore];
};